import React, { Component } from 'react'
import { Button, Modal } from 'react-bootstrap'

class MessageBox extends Component {
    constructor(props) {
        super(props);
        this.props = props;
    }

    render() {
        return (
            <Modal
            {...this.props}
            id="message-box"
            aria-labelledby="contained-modal-title-vcenter"
            className="modal-message"
            >
              <Modal.Header>
                <img onClick={this.props.onHide} className="img-fluid" src="/assets/banners/BW_SA_Jackpots_DesktopPopupBanner.jpg" alt="Banner"/>
              </Modal.Header>
              <Modal.Body className="p-0 mt-1">
                <div className="bg-dark text-center">
                {this.props.headermessage === "Success" ?
                  <p className="text-uppercase text-green">Thank you for making your picks</p>
                  :
                  <p className="text-uppercase text-not-success">Error placing your picks</p>
                }
                </div>
                <div className="message text-center px-5">
                  {this.props.headermessage === "Success" ?
                    <p className="text-center">
                      Your entry into the <strong>Daily Jackpot</strong> has been confirmed.
                      Place another bet to earn one more free ticket and another chance to
                      <strong> win your share of R{this.props.jackpot}</strong>.
                      <br/>Place more bets, get more tickets.
                    </p>
                    :
                    <p className="mx-auto text-not-success">Please make all selections</p>
                  }

                </div>

              </Modal.Body>

              <Modal.Footer className="mb-2">
                {this.props.headermessage === "Success" ?
                  <Button className="btn-success" onClick={this.props.onHide}>Back To Home</Button>
                :
                  <Button className="btn-success" onClick={this.props.onHide}>Back to Betslip</Button>
                }
              </Modal.Footer>
            </Modal>
        );
    }
}


export default MessageBox;



// WEBPACK FOOTER //
// ./components/MessageBox/index.js